/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useState, useContext, Dispatch, SetStateAction, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'

import { DriversFilters } from '../types'

type ContextState = {
  filters: DriversFilters
  setFilters: Dispatch<SetStateAction<DriversFilters>>
  isDriversSync: boolean
  setIsDriversSync: Dispatch<SetStateAction<boolean>>
  resetFilters: () => void
  resetTriggered: number
}

export const initialDriversFiltersState: ContextState = {
  filters: { page: 1, limit: 10, orderBy: 'ASC' },
  setFilters: () => {},
  isDriversSync: false,
  setIsDriversSync: () => {},
  resetFilters: () => {},
  resetTriggered: 0,
}

const DriversContext = React.createContext<ContextState>(initialDriversFiltersState)

type DriversFiltersProviderProps = {
  children: React.ReactNode
}

export function DriversFiltersProvider({ children }: DriversFiltersProviderProps) {
  const [isDriversSync, setIsDriversSync] = useState<boolean>(false)
  const [filters, setFilters] = useState<DriversFilters>(initialDriversFiltersState.filters)
  const [resetTriggered, setResetTriggered] = useState<number>(0)
  const [search] = useSearchParams()
  const resetFilters = () => {
    setResetTriggered(state => state + 1)
  }

  useEffect(() => {
    if (resetTriggered) {
      setFilters(initialDriversFiltersState.filters)
    }
  }, [resetTriggered])

  useEffect(() => {
    if (filters && search.get('service') && !filters.asnum) {
      const timeout = setTimeout(
        () =>
          setFilters(state => ({
            ...state,
            asnum: Number(search.get('service')) ?? undefined,
            page: initialDriversFiltersState.filters.page,
          })),
        0,
      )

      return () => clearTimeout(timeout)
    } else {
      setFilters(initialDriversFiltersState.filters)
    }
  }, [search])

  return (
    <DriversContext.Provider
      value={{
        filters,
        setFilters,
        isDriversSync,
        setIsDriversSync,
        resetFilters,
        resetTriggered,
      }}
    >
      {children}
    </DriversContext.Provider>
  )
}

export function useDriversContext(): ContextState {
  const context = useContext(DriversContext)
  if (!context) throw Error('This hook can only be used under the DriversFiltersProvider component')
  return context
}
